import useSWR from 'swr';
import axios from 'axios';

import { getApiUrl, formatAndThrowApiError } from '@/helpers/api';

export const useCoachActivities = (coachId) => {
  const urlStr = `${getApiUrl()}/mega/coach-activity?coachId=${coachId}`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        formatAndThrowApiError(err);
      }
    },
    {
      dedupingInterval: 30000, // 30 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useCoachActivity = (coachActivityId) => {
  const urlStr = `${getApiUrl()}/mega/coach-activity/${coachActivityId}`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        formatAndThrowApiError(err);
      }
    },
    {
      dedupingInterval: 30000, // 30 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useApproveCoachActivity = () => {
  const approveCoachActivity = async (coachActivityId) => {
    try {
      const url = `${getApiUrl()}/mega/coach-activity/${coachActivityId}/approve`;
      const response = await axios.put(url);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return approveCoachActivity;
};

export const useUnApproveCoachActivity = () => {
  const unApproveCoachActivity = async (coachActivityId) => {
    try {
      const url = `${getApiUrl()}/mega/coach-activity/${coachActivityId}/un-approve`;
      const response = await axios.put(url);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return unApproveCoachActivity;
};

export const useRejectCoachActivity = () => {
  const rejectCoachActivity = async (coachActivityId, payload) => {
    try {
      const url = `${getApiUrl()}/mega/coach-activity/${coachActivityId}/reject`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return rejectCoachActivity;
};

export const useCoachActivityContract = (coachActivityId) => {
  const urlStr = `${getApiUrl()}/mega/coach-activity/${coachActivityId}/contract`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 30000, // 30 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useCoachActivityContractPdf = (coachActivityId) => {
  const urlStr = `${getApiUrl()}/mega/coach-activity/${coachActivityId}/contract-pdf`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const result = await axios.get(url, { responseType: 'blob' });
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });
  return swr;
};
